var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenfull",attrs:{"title":_vm.isFullscreen ? '退出全屏' : '全屏'},on:{"click":_vm.click}},[_c('i',{staticClass:"iconfont screenfull-icon",class:[_vm.isFullscreen ? 'icon-fullscreen-shrink' : 'icon-fullscreen-expand']})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1988bea2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/screenfull.vue
// module id = null
// module chunks = 